import PhotoSheet from 'components/photo-sheet/PhotoSheet';
import Typography from 'components/typography/Typography';
import { TYPOGRAPHY_VARIANTS } from 'components/typography/typography-utils';
import { I18nNamespace } from 'constants/i18n.const';
import { useBoothAppContext } from 'context/BoothAppContext';
import { isEqualVal } from 'helpers/string.helper';
import { processedImageUrl } from 'helpers/url.helper';
import { find, map } from 'lodash';
import React, { useMemo, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from 'store/store-hooks';
import { getImageFileAfterEditPhoto } from '../../../helpers/image.helper';

type EditPhotoSheetPreviewProps = {
  isInStickerPage?: boolean;
  isShowWarningNotShowingOnVideo?: boolean;
};

const EditPhotoSheetPreview: React.FC<EditPhotoSheetPreviewProps> = ({
  isInStickerPage,
  isShowWarningNotShowingOnVideo,
}) => {
  const refTarget = useRef<HTMLInputElement | null>(null);
  const { t } = useTranslation([I18nNamespace.COMMON, I18nNamespace.PAGE]);
  const { themeDetail, currentLayout, listFilterPhotos } = useBoothAppContext();
  const { transactionId, pickedPhotos, filterId, backgroundId, filterType } =
    useAppSelector((state) => state.selfeApp);

  const colorMatrixValues = useMemo(
    () =>
      find(listFilterPhotos?.data, (o) => isEqualVal(o?.id, filterId))
        ?.colorMatrix,
    [listFilterPhotos, filterId],
  );

  return (
    <div className="edit-page__edit-photo-sheet--wrapper">
      <PhotoSheet
        className="edit-page__edit-photo-sheet"
        forwardedRef={refTarget}
        isSelectSticker={isInStickerPage}
        data={{
          ...currentLayout,
          pictures: map(currentLayout?.pictures, (item, ind: number) => ({
            ...item,
            image: pickedPhotos?.[ind]
              ? processedImageUrl(
                  transactionId,
                  getImageFileAfterEditPhoto(
                    filterId,
                    filterType,
                    backgroundId,
                    ind,
                    pickedPhotos,
                  ),
                )
              : '',
            rotate: pickedPhotos?.[ind]?.rotate,
            flip: pickedPhotos?.[ind]?.flip,
          })),
          image: themeDetail?.image || currentLayout?.image,
        }}
        filterValues={colorMatrixValues}
      />
      {isShowWarningNotShowingOnVideo && (
        <Typography
          className="font-semibold mt-7 sticker-page__warning-text"
          variant={TYPOGRAPHY_VARIANTS.SMALL}
          firstCapCase
        >
          {t('page:warningSticker')}
        </Typography>
      )}
    </div>
  );
};
export default EditPhotoSheetPreview;
